import { classNames as clsx } from "@alpacahq/ui/old";

type AsteriskProps = {
  required?: boolean;
  className?: string;
};

export const Asterisk = ({ required, className }: AsteriskProps) => (
  <span
    className={clsx(
      "text-red-400",
      required ? "inline-block" : "hidden",
      className,
    )}
  >
    *
  </span>
);
